import { render, staticRenderFns } from "./CheckoutShipping.vue?vue&type=template&id=36313f78&"
import script from "./CheckoutShipping.vue?vue&type=script&lang=ts&"
export * from "./CheckoutShipping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36313f78')) {
      api.createRecord('36313f78', component.options)
    } else {
      api.reload('36313f78', component.options)
    }
    module.hot.accept("./CheckoutShipping.vue?vue&type=template&id=36313f78&", function () {
      api.rerender('36313f78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/pages/checkout/CheckoutShipping.vue"
export default component.exports